export const errorMessage = {
    somethingWentWrong: 'Something went wrong, Please try again!',
    invalidPartner: 'Invalid Partner, Please Enter a Valid Partner URL!',
    invalidFacility: 'Unable to Fetch Facility, Please Try Again!',
    notFound: 'PAGE NOT FOUND',
    loginNotes : 'You will need to log in or create an account to continue',
    registeration: 'Registration completed successfully. Please login!',
    noDataAvailable : 'No data Available!',
    invalidQrCode: 'Please scan the valid QR Code',
    activeCheckinMessage: 'We found an Active Check-in against this License Plate & Mobile Number. Do you want to check the details ?'

}